module.exports = __webpack_public_path__ + "img/icon_1.f401698.svg";